import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import theme from '../../../../theme/theme';
// import getConfig from 'next/config';
import getStrapiData from '../../../../integration/strapi';
import MbbContainer from '../../../../components/eir-mobile-broadband/MbbContainer';
// mport EirLogOut from '../../../../components/eir-logout/EirLogOut';
import LoginModal from '../../../../components/eir-login/LoginModal';
// import NotificationBanner from '../../../../components/eir-notification-banner/NotificationBanner';
import { clearAllCookies, getCookie, getTokenFromCookies } from '../../../../hooks/useCookie';
import { useToggle } from '../../../../hooks/useToggle';
import validateCart from '../../../../components/shared/validateCart';
import eligibilityCheck from '../../../../components/shared/eligibilityCheck';
import EirRegistrationRequiredModal from '../../../../components/eir-login/EirRegistrationRequiredModal';
import EirMetaTag from '../../../../components/eir-meta-tag/EirMetaTag';
import EirFooter from '../../../../components/eir-footer/EirFooter';
import EirHeader from '../../../../components/eir-header/EirHeader';
import MfaOtpModal from '../../../../components/eir-login/MfaOtpModal';
import MfaSuccessModal from '../../../../components/eir-login/MfaSuccessModal';

// const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps({ req }) {
  let eligibility = {};
  let cmsHeaderData = {};
  let cmsFooterData = {};

  const cmsData = await getStrapiData('mobile');
  const cmsDataLoginBanner = await getStrapiData('notification-banner');
  cmsHeaderData = await getStrapiData('header');
  cmsFooterData = await getStrapiData('footer');
  const result = await validateCart(req.cookies);
  if (result.token) eligibility = await eligibilityCheck({ token: result.token });

  return {
    props: {
      cmsData: cmsData?.data,
      cmsDataLoginBanner,
      eligibility,
      cmsHeaderData,
      cmsFooterData,
    },
  };
}

const Broadband = ({
  cmsData,
  // cmsDataLoginBanner,
  // eligibility,
  cmsHeaderData,
  cmsFooterData,
}) => {
  // const theme = useTheme();
  const openJourneyPicker = useToggle(false);
  const [loginModal, setLoginModal] = useState(false);
  const registrationIncompleteModal = useToggle(false);
  const mfaOtpModal = useToggle(false);
  const mfaSuccessModal = useToggle(false);
  const errorModal = useToggle(false);
  const [userValue, setUserValue] = useState('');
  const [delivery, setDelivery] = useState('');
  const [otpUUID, setOtpUUID] = useState('');
  // const handleLogin = () => {
  //   setLoginModal(true);
  // };
  const onPageLoad = () => {
    if (getTokenFromCookies() && !getCookie('cart_Type')) {
      openJourneyPicker.enable();
    }
  };
  useEffect(() => {}, []);
  useEffect(() => {
    if (getCookie('PREPAY_REFERENCE')) {
      clearAllCookies();
      localStorage.clear();
    }
  }, []);
  return (
    <>
      <EirMetaTag seo={cmsData?.attributes?.Seo_Mbb} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <Grid
          container
          sx={{
            backgroundSize: '100%',
            backgroundColor: theme.palette.primary.backgroundColor2,
            minHeight: '100vh',
            justifyContent: 'center',
          }}
        >
          {/* <NotificationBanner
        desktopText={
          <p>
            <span style={{ fontWeight: 700 }}>
              {cmsDataLoginBanner?.data?.attributes?.desktopDescriptionFirstHalf}
            </span>{' '}
            {cmsDataLoginBanner?.data?.attributes?.desktopDescriptionSecondHalf}
          </p>
        }
        mobileText={cmsDataLoginBanner?.data?.attributes?.mobileDescription}
        cta={{
          ctaText: 'Log in to see deals',
          type: 'solid',
          action: () => handleLogin(),
          disableCta: false,
        }}
        logoutCta={<EirLogOut ctaText='Log out' />}
      /> */}
          <MbbContainer cmsData={cmsData} />
          {loginModal && (
            <LoginModal
              enable={loginModal}
              registrationIncompleteModal={registrationIncompleteModal}
              mfaOtpModal={mfaOtpModal}
              setUserValue={setUserValue}
              setDelivery={setDelivery}
              mfaSuccessModal={mfaSuccessModal}
              setOtpUUID={setOtpUUID}
              setEnableModal={setLoginModal}
              prequal={false}
              onload={onPageLoad}
            />
          )}
          {mfaOtpModal.value && (
            <MfaOtpModal
              mfaOtpModal={mfaOtpModal}
              delivery={delivery}
              userValue={userValue}
              errorModal={errorModal}
              otpUUID={otpUUID}
              setOtpUUID={setOtpUUID}
              mfaSuccessModal={mfaSuccessModal}
            />
          )}
          {mfaSuccessModal.value && <MfaSuccessModal mfaSuccessModal={mfaSuccessModal} />}
          {registrationIncompleteModal.value && (
            <EirRegistrationRequiredModal
              registrationIncompleteModal={registrationIncompleteModal}
            />
          )}
          {/* <EirJourneyPickerModal
        titleName={eligibility?.contactDetails?.firstName}
        openJourneyPicker={openJourneyPicker}
        // openKeepNumberCheck={openKeepNumberCheck}
        graphql={graphql}
      /> */}
          <EirFooter cmsFooterData={cmsFooterData?.data} />
        </Grid>
      </main>
    </>
  );
};

export default Broadband;
